import $ from 'jquery';
import _ from 'underscore';
import Flickity from 'flickity';
import StateManager from '../scuba/StateManager';

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
    $(node).find('.js-topics').each(function(i, el) {
        new Topics(el);
    });
});


/* --------------------------------------------------

    CLASS

-------------------------------------------------- */

function Topics() {
    this.initialize.apply(this, arguments);
}

$.extend(Topics.prototype, {

    initialize: function(el) {
      var self = this;
      self.uid = _.uniqueId('scuba-');
      self.$el = $(el);
      self.firstSelection = false;
      self.stopAll = false;

      self.$header = self.$el.find(".js-topics__header");
      self.$fixedHeader = self.$el.find(".js-topics__fixed-header");
      self.$topics = self.$el.find(".js-topics__topic");
      self.$main = self.$el.find(".js-topics__main");

      $(document.body).on('layout:change.'+self.uid, $.proxy(self.invalidateLayout, self));
      self.invalidateLayout();

      var start = 0;
      if(typeof self.$el.attr('data-active') !== "undefined"){
        start = $(`#topic-${self.$el.attr('data-active')}`).attr("data-key");
      }

      self.flkty = new Flickity(self.$header.get(0), {
        cellSelector: '.js-topics__topic',
        setGallerySize: true,
        resize: false,
        adaptiveHeight: true,
        autoPlay: 7000,
        initialIndex: start,
        prevNextButtons: false,
      });

      self.fixedFlkty = new Flickity(self.$fixedHeader.get(0), {
        setGallerySize: true,
        resize: false,
        initialIndex: start,
        prevNextButtons: false,
      });

      self.fixedFlkty.on('dragMove', function(){
        self.stopAllPlayers();
      });

      self.flkty.on('dragMove', function(){
        self.stopAllPlayers();
      });

      self.flkty.on('staticClick', function(event, pointer, cellElement) {
        if($(cellElement).find('.js-topics__scroll-down').is(":visible")){
          self.$scroller.animate({
            scrollTop: $(cellElement).find(".js-topics__scroll-down").offset().top + self.$scroller.scrollTop(),
          });
        } else {
          StateManager.pushState($(cellElement).data("url"));
        }
      });

      self.fixedFlkty.on('staticClick', function() {
        self.$scroller.animate({
          scrollTop: 0,
        });
      });

      $(window).on('resize', function() {
        $.proxy(self.resize, self)();
      });

      $(window).on(StateManager.STATE_CHANGE, function() {
        setTimeout(function(){
          $.proxy(self.resize, self)();
        }, 300);
      });

      $.proxy(self.resize, self)();

      self.flkty.on('select', function() {
        var $selectedTopic = self.$topics.eq(self.flkty.selectedIndex);
        var color = $selectedTopic.css("color");
        self.$main.empty();
        $selectedTopic.find('.js-topics__topic__main').clone().appendTo(self.$main);
        self.$el.css({
          "color": $selectedTopic.css("color"),
          "backgroundColor": $selectedTopic.css("backgroundColor"),
        });
        self.$el.find(".flickity-page-dots").css("color", color);

        if(typeof self.$el.attr('data-clickonfirst') !== "undefined" && !self.firstSelection && $("body").hasClass('s-desktop')){
          self.$main.find(".js-topics__topic__item").first().click();
        }

        self.firstSelection = true;
      });

      self.fixedFlkty.on('select', function() {
        self.flkty.select(self.fixedFlkty.selectedIndex);
      });
    },

    stopAllPlayers: function() {
      const self = this;
      self.stopAll = true;
      self.flkty.stopPlayer();
    },

    playOrPause: function() {
      const self = this;

      if(!self.$el.hasClass('has-fixed-header') && self.$el.closest(".js-scuba__page").is(':last-child') && !self.stopAll) {
        self.flkty.playPlayer();
      } else {
        self.flkty.stopPlayer();
      }
    },

    resize: function() {
      const self = this;
      self.$topics.css("height", "");
      let maxHeight = 0;
      self.$topics.each((index, step) => {
        maxHeight = Math.max(maxHeight, $(step).outerHeight());
      });
      self.$topics.css("height", `${maxHeight}px`);
      self.flkty.resize();
      self.fixedFlkty.select(self.flkty.selectedIndex, false, true);
      self.fixedFlkty.resize();

      self.playOrPause();

    },

    invalidateLayout: function() {
      var self = this;
      if($("body").hasClass('s-desktop')){
        self.$scroller = self.$el.find('.js-topics__scroller');
      } else {
        self.$scroller = $("html, body");
      }
      $("html, body").off("scroll.topics");
      self.$el.find('.js-topics__scroller').off("scroll.topics");
      self.$scroller.on('scroll.topics', function() {
        var top = self.$main.offset().top;
        self.stopAllPlayers();
        if(top <= 60 && self.$el.hasClass('has-fixed-header') || top > 60 && !self.$el.hasClass('has-fixed-header')){
          return;
        }
        if(top <= 60){
          self.$el.addClass('has-fixed-header');
          //self.fixedFlkty.resize();
          self.fixedFlkty.select(self.flkty.selectedIndex, false, true);
        } else {
          self.$el.removeClass('has-fixed-header');
        }
        self.flkty.resize();
      });
    },
});



// WEBPACK FOOTER //
// ./scripts/components/Topics.js